import {
    Box,
    Flex,
    Grid,
} from "@chakra-ui/react";

import {
    useEffect,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import PageHeader from "../Dashboard/components/PageHeader";

import AnalyticsStats from "./components/AnalyticsStats";
import GrowthChart from "./components/GrowthChart";
import FunnelAnalytics from "./components/FunnelAnalytics";
import TopRecruitsTable from "./components/TopRecruitsTable";
import CommissionLiability from "./components/CommissionLiability";
import DriverLocations from "./components/DriverLocations";

import {
    fetchReferredDriversAction,
    fetchReferralMilestonesAction,
} from "../../state/actions/driverPartnerActions";

import {
    fetchDriverByIdAction,
    fetchRecruitedVehiclesAction,
} from "../../state/actions/driverActions";

const Analytics = () => {
    const dispatch =
        useDispatch();

    const {
        driverPartner,
        referredDrivers = [],
        referralMilestones = [],
        loading,
    } = useSelector(
        state =>
            state.driverPartner
    );

    const {
        drivers: driverDetails = {},
        recruitedVehicles = [],
    } = useSelector(
        state =>
            state.driver
    );

    useEffect(() => {
        dispatch(
            fetchReferredDriversAction(
                1,
                100
            )
        );

        dispatch(
            fetchReferralMilestonesAction()
        );

        dispatch(
            fetchRecruitedVehiclesAction(
                1,
                100
            )
        );
    }, [
        dispatch,
    ]);

    useEffect(() => {
        referredDrivers
            .filter(
                recruit =>
                    recruit.driver
                        ?.driver_id
            )
            .forEach(
                recruit => {
                    dispatch(
                        fetchDriverByIdAction(
                            recruit.driver
                                .driver_id
                        )
                    );
                }
            );
    }, [
        referredDrivers,
        dispatch,
    ]);

    return (
        <Flex
            h="100vh"
            bg="#F8FAFC"
            overflow="hidden"
        >
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="Analytics"
                        subtitle="Monitor recruit performance, partner growth, commissions and operational insights."
                    />

                    <AnalyticsStats
                        drivers={
                            referredDrivers
                        }
                        milestones={
                            referralMilestones
                        }
                    />

                    {/* Growth Chart */}

                    <Box mt={8}>
                        <GrowthChart
                            drivers={
                                referredDrivers
                            }
                            milestones={
                                referralMilestones
                            }
                        />
                    </Box>

                    {/* Funnel + Commission */}

                    <Grid
                        mt={6}
                        gap={6}
                        templateColumns={{
                            base: "1fr",
                            lg: "1fr 1fr",
                        }}
                    >
                        <FunnelAnalytics
                            drivers={
                                referredDrivers
                            }
                            milestones={
                                referralMilestones
                            }
                        />

                        <CommissionLiability
                            milestones={
                                referralMilestones
                            }
                        />
                    </Grid>

                    {/* Driver Locations */}

                    <Box mt={6}>
                        <DriverLocations
                            driverDetails={Object.values(
                                driverDetails
                            )}
                        />
                    </Box>

                    {/* Top Recruits */}

                    <Box mt={6}>
                        <TopRecruitsTable
                            partner={
                                driverPartner
                            }
                            drivers={
                                referredDrivers
                            }
                            milestones={
                                referralMilestones
                            }
                        />
                    </Box>
                </Box>
            </Flex>
        </Flex>
    );
};

export default Analytics;